import { render, staticRenderFns } from "./ShippingPostcodeAdditionalFeeCreate.vue?vue&type=template&id=23907444&"
import script from "./ShippingPostcodeAdditionalFeeCreate.vue?vue&type=script&lang=js&"
export * from "./ShippingPostcodeAdditionalFeeCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports